import React, { useState, createContext, useContext } from 'react';
import { translations, Language } from '../lib/translations';
interface LanguageContextType {
  lang: Language;
  toggleLang: () => void;
  t: (section: keyof typeof translations.es, key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<Language>('es');
  const toggleLang = () => {
    setLang(prev => prev === 'es' ? 'en' : 'es');
  };
  const t = (section: keyof typeof translations.es, key: string): string => {
    try {
      // @ts-ignore
      return translations[lang][section][key] || key;
    } catch (e) {
      return key;
    }
  };
  return <LanguageContext.Provider value={{
    lang,
    toggleLang,
    t
  }} data-id="element-210">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}